import { useSelector, shallowEqual } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useMeterType } from './useMeterType';
import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';
import { selectIsDualRate } from 'state/quote/quote-slice';

export const useElecMultirate = () => {
  const { configTimeOfUseTariff } = useFlags();
  const { hasElectricityTOUMeter, hasE7Meter } = useMeterType();
  const hasElectricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const choseDualRateE7 = useSelector(selectIsDualRate, shallowEqual);

  const showTOUTariffs = !!(
    configTimeOfUseTariff &&
    hasElectricityTOUMeter &&
    hasElectricVehicle
  );
  const showE7Tariffs = !!(hasE7Meter && choseDualRateE7);

  return {
    showTOUTariffs,
    showE7Tariffs
  };
};
